import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6h-5.6z"
}), 'AssistantPhotoSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/AssistantPhotoSharp.js
// module id = 2178
// module chunks = 2